module.exports = __webpack_public_path__ + "img/mr.a46829f1.svg";